import React, {Component} from 'react'

import Screen from '../ui/Screen'
import ControlPanel from "./InventoryScreen/ControlPanel"
import CategoriesPanel from "./InventoryScreen/CategoriesPanel"
import SearchPanel from "./InventoryScreen/SearchPanel"
import CreateFolderDialog from "./InventoryScreen/CreateFolderDialog"
import CreateItemDialog from "./InventoryScreen/CreateItemDialog"
import EditItemDialog from "./InventoryScreen/EditItemDialog"
import EditFolderDialog from "./InventoryScreen/EditFolderDialog"
import DeleteFolderDialog from "./InventoryScreen/DeleteFolderDialog"
import DeleteItemDialog from "./InventoryScreen/DeleteItemDialog"
import ErrorMessageDialog from "./../ui/ErrorMessageDialog"

import SelectFolderDialog from "./../ui/SelectFolderDialog"
import ExpandState from "./../ui/ExpandState"
import TreeList from "./../ui/TreeList"
import ItemIcon from '@material-ui/icons/BeachAccess'

import Cookie from "../Cookie"
import {config} from "../config"

/**
 * <InventoryScreen />
 */

class InventoryScreen extends Component {

	constructor(props) {
		super(props)
		this.handleCreateFolder = this.handleCreateFolder.bind(this)
		this.handleCreateItem = this.handleCreateItem.bind(this)
		this.handleEditItem = this.handleEditItem.bind(this)
		this.handleDeleteItem = this.handleDeleteItem.bind(this)
		this.handleClickItem = this.handleClickItem.bind(this)
		this.handleSearchPanelChange = this.handleSearchPanelChange.bind(this)
		this.handleAttachCategory = this.handleAttachCategory.bind(this)
		this.handleDetachCategory = this.handleDetachCategory.bind(this)
		this.handleError = this.handleError.bind(this)
		this.handleMoveToFolder = this.handleMoveToFolder.bind(this)
	}

	state = {
		items: [],
		selected: undefined,
		dialog: undefined,
		filters: [],
		searchString: "",
	}

	expandState = new ExpandState()

	getItems() {
		return new Promise((resolve, reject) => {
			let filter = "&filter=" + this.state.filters.map(item => item.id).join(",")
			let search = this.state.searchString ? `&search=${encodeURIComponent(this.state.searchString)}` : ""
			let xhr = new XMLHttpRequest()
			xhr.open("GET", config.restApiHost + `/inventory/items?sid=${Cookie.get("sid")}${filter}${search}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)

						// получаем указатель на папку владельца
						let normalize = (items, parent) => {
							if (items) {
								for(let item of items) {
									item.parent = parent
									if (item.type === "0") {
										item.items = normalize(item.items, item)
									}
								}
							}
							return items
						}

						resolve(normalize(json, undefined))
					} else {
						reject("Не удалось получить список предметов")
					}
				}
			}
			xhr.send()
		})
	}

	createItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("POST", config.restApiHost + `/inventory/item?sid=${Cookie.get("sid")}`)
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось создать предмет")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	updateItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/inventory/item/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось обновить данные предмета")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	deleteItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("DELETE", config.restApiHost + `/inventory/item/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось удалить предмет")
					}
				}
			}
			xhr.send()
		})
	}

	findNewSelected(selected, items) {
		if (selected) {
			for(let item of items) {
				if (item.id === selected.id) {
					return item
				}
				if (item.type.toString() === "0") {
					let itm = this.findNewSelected(selected, item.items)
					if (itm) {
						return itm
					}
				}
			}
		}
	}

	update() {
		return new Promise((resolve, reject) => {
			this.getItems().then(items => {
				this.expandState.updateTree(items)
				this.setState({
					items: items,
					selected: this.expandSelectedParents(this.findNewSelected(this.state.selected, items))
				}, resolve)
			}, reject)
		})
	}

	componentDidMount() {
		this.update().catch(this.handleError)
	}

	handleError(errorMessage) {
		this.setState({
			dialog: <ErrorMessageDialog
				message = {errorMessage}
				onClose = {() => {
					this.update().then(() => {
						this.setState({
							dialog: undefined
						})
					}, this.handleError)
				}}
			/>
		})
	}

	handleCreateFolder() {
		this.setState({
			dialog: <CreateFolderDialog
				selected = {this.state.selected}
				onCreateFolder = {folder => {
					this.createItem(folder).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleCreateItem() {
		this.setState({
			dialog: <CreateItemDialog
				selected = {this.state.selected}
				onCreateItem = {item => {
					this.createItem(item).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleEditItem(item) {
		if (item.type === "1") {
			this.setState({
				dialog: <EditItemDialog
					item = {item}
					onUpdateItem = {item => {
						this.updateItem(item).then(() => {
							this.update().then(() => {
								this.setState({
									dialog: undefined
								})
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		} else {
			this.setState({
				dialog: <EditFolderDialog
					folder = {item}
					onUpdateFolder = {folder => {
						this.updateItem(folder).then(() => {
							this.update().then(() => {
								this.setState({
									dialog: undefined
								})
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		}
	}

	handleDeleteItem(item) {
		if (item.type === "1") {
			this.setState({
				dialog: <DeleteItemDialog
					item = {item}
					onDeleteItem = {item => {
						this.deleteItem(item).then(() => {
							this.update().then(() => {
								this.setState({
									selected: undefined,
									dialog: undefined,
								})
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		} else {
			this.setState({
				dialog: <DeleteFolderDialog
					folder = {item}
					onDeleteFolder = {folder => {
						this.deleteItem(folder).then(() => {
							this.update().then(() => {
								this.setState({
									selected: undefined,
									dialog: undefined,
								})
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		}
	}

	handleClickItem(item) {
		if (this.state.selected ? this.state.selected.id === item.id : false) {
			if (this.state.selected.type === "0") {
				item.expand = !item.expand
				this.expandState.set(item.id, item.expand)
				this.forceUpdate()
			} else {
				this.handleEditItem(item)
			}
		} else {
			this.setState({
				selected: this.expandSelectedParents(item)
			})
		}
	}

	handleSearchPanelChange(searchString) {
		this.setState({
			searchString: searchString
		}, this.update)
	}

	handleAttachCategory(category) {
		this.state.filters.push(category)
		this.update()
	}

	handleDetachCategory(category) {
		this.setState({
			filters: this.state.filters.filter(f => f.id !== category.id)
		}, this.update)
	}

	expandSelectedParents(item) {
		let itm = item
		if (itm) {
			while(itm.parent) {
				itm.expand = true
				this.expandState.set(itm.id, itm.expand)
				itm = itm.parent
			}
		}
		return item
	}

	/**
	 * Проверяет, можно ли скопировать итем или папку в заданную папку
	 * Нельзя, если item = папка и заданная папака находится
	 * внутри копируемой папки или является собой (нельзя копировать в себя)
	 */

	itemReadyToMove(item, folder) {
		return new Promise((resolve, reject) => {

			let scan = f => {
				if (!folder) { // любую папку можно коипировать в корень
					return true
				}
				if (f.id === folder.id) {
					return false
				}
				for (let itm of f.items) {
					if (itm.type === "0") {
						if (!scan(itm)) {
							return false
						}
					}
				}
				return true
			}

			if (item.type === "0") { // move folder
				if (scan(item)) {
					resolve(item, folder)
				} else {
					reject("Нельзя копировать папку в себя, или во вложенные папки")
				}
			} else { // move item
				resolve(item, folder)
			}

		})
	}

	moveToFolder(item, folder) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/inventory/item/${item.id}/folder/${folder.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Ну изменить родительскую папку")
					}
				}
			}
			xhr.send()
		})
	}

	handleMoveToFolder(item) {
		this.getItems().then(items => {
			this.setState({
				dialog: <SelectFolderDialog
					items = {items}
					disableFolder = {item}
					onSelectFolder = {folder => {
						this.itemReadyToMove(item, folder).then(result => {
							this.moveToFolder(item, folder).then(() => {
								this.update().then(() => {
									this.setState({
										selected: this.expandSelectedParents(item),
										dialog: undefined,
									})
								}, this.handleError)
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		})
	}

	render() {

		if (!this.state.items) {
			return null
		}

		return <Screen
			onClick = {e => {
				e.stopPropagation()
				this.setState({
					selected: undefined
				})
			}}
		>

			{this.state.dialog}

			<ControlPanel
				selected = {this.state.selected}
				onCreateFolderClick = {this.handleCreateFolder}
				onCreateItemClick = {this.handleCreateItem}
				onMoveToFolderClick = {this.handleMoveToFolder}
				onEditItemClick = {this.handleEditItem}
				onDeleteItemClick = {this.handleDeleteItem}
			/>

			<CategoriesPanel
				title = "Фильтры"
				parent = {this}
				categories = {this.state.filters}
				onAttachCategory = {this.handleAttachCategory}
				onDetachCategory = {this.handleDetachCategory}
			/>

			<SearchPanel
				onChange = {this.handleSearchPanelChange}
			/>

			<TreeList
				items = {this.state.items}
				selected = {this.state.selected}
				itemIcon = {<ItemIcon/>}
				onClickItem = {this.handleClickItem}
			/>

		</Screen>

	}

}

export default InventoryScreen
